import { useState } from 'react';
import { ServiceRegistry } from '../../../../core/ServiceRegistry';

export interface PlayerWhereabouts { mapId: string; x: number; y: number }

/**
 * Where the local player stands right now (current level id + world position),
 * read once from the running game's services — the same sources the corner
 * minimap polls. Null outside the game (tests, pre-game screens).
 */
export function readPlayerWhereabouts(): PlayerWhereabouts | null {
  try {
    const registry = ServiceRegistry.getInstance();
    if (!registry.has('MapSystem') || !registry.has('EntitySystem')) return null;
    const mapId = registry.get('MapSystem')?.getCurrentLevel?.()?.id;
    const position = registry.get('EntitySystem')?.getPlayerManager?.()?.getPlayer?.()?.position;
    if (typeof mapId !== 'string' || typeof position?.x !== 'number' || typeof position?.y !== 'number') return null;
    return { mapId, x: position.x, y: position.y };
  } catch {
    return null;
  }
}

/** Snapshot on mount: the quest window is opened standing still at an NPC. */
export function usePlayerWhereabouts(): PlayerWhereabouts | null {
  const [where] = useState(readPlayerWhereabouts);
  return where;
}
